export default "__VITE_ASSET__B21V_7aF__"